import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardTitle, CardText } from 'react-toolbox/lib/card';
import LoadingOverlay from '../../../common/components/LoadingOverlay';
import Form from '../../../common/components/Form';
import styles from './Template.css';

const Template = ({
  title = '',
  formSubmit,
  formInputs = [],
  formState = {},
  formErrors,
  children,
  isLoading = false,
}) => {
  return (
    <Card className={styles.authCard} theme={styles}>
      {title && title.length ? <CardTitle title={title} /> : null}
      <CardText>
        {formInputs.length && formSubmit ? (
          <Form
            initState={formState}
            formSubmit={formSubmit}
            formInputs={formInputs}
            formErrors={formErrors}
          >
            {children}
          </Form>
        ) : (
          children
        )}
      </CardText>
      <LoadingOverlay isLoading={isLoading} />
    </Card>
  );
};

Template.propTypes = {
  title: PropTypes.node,
  formState: PropTypes.object,
  formSubmit: PropTypes.func,
  formInputs: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.func])
  ),
  formErrors: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
  isLoading: PropTypes.bool,
};

export default Template;



// WEBPACK FOOTER //
// ./src/App/auth/components/Template.js